<template>
    <div>

        <rkm-form
            v-if="!!data"
            ref="FormAtendimentoDomiciliar"
        >

        <rkm-row class="flex-nowrap">
            
            <rkm-col class="flex-grow-1">
                
                    <rkm-form-select
                        :options="data.form.faturamento.atendimentoDomiciliar.registroTipo"
                        textField="descricao"
                        valueField="id"
                        label="Registrar como"
                        v-model="model.registroTipoId"
                        :validations="validations.registroTipoId"
                        title="Para procedimentos que tenham ambos os instrumentos de registro"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {
    
            return {
                registroTipoId: { required: true },
            }
        },
    },
    created: function() {

        this.model.registroTipoId = this.data.model.faturamento.atendimentoDomiciliar.registroTipoId
    },
    data: () => ({
        model: {
            registroTipoId: null,
        },
    }),
    methods: {
        async validate() {

            return true
        },
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    },
    watch: {
        'model.registroTipoId': function (registroTipoId) {

            this.data.model.faturamento.atendimentoDomiciliar.registroTipoId = registroTipoId
        },
    }
}
    
</script>